<template lang="pug">
.adobesign
  ManagementPage(title="AdobeSign Integration"
                info="Configuration for signing feature"
                :creatable="false"
                :searchable="false")

  .adobesign-config(v-if="this.config !== null")
    aiq-col.padding-10(:span="12")
      shared-auth-config(:name='name'
                         :config="config"
                         title="AdobeSign OAuth Configuration"
                         @update="onChange")

    aiq-col.padding-10(v-if="this.config.enabled" :span="12")
      .form-container
        .sub-header--solid Adobe Sign Configuration
        .form__inner-content
          .form-field-container
            .form-field-label Authentication Domain
            aiq-input(v-model="this.config.adobesign.api_host"
                      placeholder="https://api.na3.adobesign.com:443/api/rest/v6"
                      size="small"
                      @change="onSpecificChange('api_host', $event)")
</template>

<script>
import { DOCUMENT_INTEGRATION } from '@/constants/integration';
import SharedAuthConfig from './SharedAuthConfig.vue';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';

export default {
  name: 'adobesign-tab',
  components: {
    SharedAuthConfig,
    ManagementPage,
  },
  computed: {
    name() {
      return DOCUMENT_INTEGRATION.ADOBE_SIGN;
    },
  },
  data() {
    return {
      config: null,
    };
  },
  async mounted() {
    if (!this.name) {
      throw new Error(`name attribute should be set to use this component but ${this.name}`);
    }

    this.config = await this.$store.dispatch('integrations/getIntegration', { name: this.name });
  },
  methods: {
    async onUpdate(newConfig) {
      try {
        this.config = await this.$store.dispatch('integrations/updateIntegration', {
          name: this.name,
          payload: newConfig,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(`Failed: ${err.message}`);
      }
    },
    async onChange(subObject) {
      await this.onUpdate({ ...this.config, ...subObject });
    },

    async onSpecificChange(field, value) {
      const adobesign = { ...this.config.adobesign, [field]: value };
      await this.onUpdate({ ...this.config, adobesign });
    },
  },
};
</script>

<style lang="scss" scoped>
.form__inner-content {
  background: #FFFFFF;
  border: 1px solid #E0E6ED;
  display: flex;
  flex-direction: column;
  padding: 18px;
}

.padding-10 {
  padding: 10px;
}
</style>
